module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_12.f4eeb18d.webp";